// Dev-only mock partners covering every display scenario.
// Imported by Partners.vue and PartnersCaroussel.vue; tree-shaken in production builds.

const yesterday = new Date(Date.now() - 864e5).toISOString().slice(0, 10);
const nextMonth = new Date(Date.now() + 30 * 864e5).toISOString().slice(0, 10);

export const MOCK_PARTNERS = [
  // ── Paying partners (active, no expiry) ──────────────────────────────────
  {
    id: "mock-paying-1",
    name: "Alpin Gear Co.",
    url: "#",
    image: "https://dummyimage.com/300x100/1a3a5c/ffffff&text=Alpin+Gear+Co.",
    active: true,
    isPaying: true,
    expiresAt: null,
  },
  {
    id: "mock-paying-2",
    name: "RapidFlow Equipment",
    url: "#",
    image: "https://dummyimage.com/300x100/1a5c2e/ffffff&text=RapidFlow+Equipment",
    active: true,
    isPaying: true,
    expiresAt: null,
  },

  // ── Paying partner with future expiry (still visible) ────────────────────
  {
    id: "mock-paying-expiring",
    name: "KayakFest 2026 ⏳",
    url: "#",
    image: "https://dummyimage.com/300x100/5c4a1a/ffffff&text=KayakFest+2026",
    active: true,
    isPaying: true,
    expiresAt: nextMonth,
  },

  // ── Paying partner already expired (must NOT show outside admin) ─────────
  {
    id: "mock-paying-expired",
    name: "PaddleExpo 2025 (expired)",
    url: "#",
    image: "https://dummyimage.com/300x100/5c1a1a/ffffff&text=PaddleExpo+2025",
    active: true,
    isPaying: true,
    expiresAt: yesterday,
  },

  // ── Free partners (active, no expiry) ────────────────────────────────────
  {
    id: "mock-free-1",
    name: "AquaSport",
    url: "#",
    image: "https://dummyimage.com/300x100/2e5c4a/ffffff&text=AquaSport",
    active: true,
    isPaying: false,
    expiresAt: null,
  },
  {
    id: "mock-free-2",
    name: "MontagnePlein Air",
    url: "#",
    image: "https://dummyimage.com/300x100/3b3b5c/ffffff&text=MontagnePlein+Air",
    active: true,
    isPaying: false,
    expiresAt: null,
  },
  {
    id: "mock-free-3",
    name: "RivièresSauvages",
    url: "#",
    image: "https://dummyimage.com/300x100/1a5c5c/ffffff&text=RivièresSauvages",
    active: true,
    isPaying: false,
    expiresAt: null,
  },

  // ── Free partner with future expiry (still visible) ──────────────────────
  {
    id: "mock-free-expiring",
    name: "EcoRando Été ⏳",
    url: "#",
    image: "https://dummyimage.com/300x100/4a5c1a/ffffff&text=EcoRando+Été",
    active: true,
    isPaying: false,
    expiresAt: nextMonth,
  },

  // ── Free partner already expired (must NOT show outside admin) ───────────
  {
    id: "mock-free-expired",
    name: "TorrentWeek 2024 (expired)",
    url: "#",
    image: "https://dummyimage.com/300x100/5c3b1a/ffffff&text=TorrentWeek+2024",
    active: true,
    isPaying: false,
    expiresAt: yesterday,
  },

  // ── Inactive partner (must NEVER show outside admin) ─────────────────────
  {
    id: "mock-inactive",
    name: "OldSponsor (inactive)",
    url: "#",
    image: "https://dummyimage.com/300x100/3b3b3b/ffffff&text=OldSponsor",
    active: false,
    isPaying: false,
    expiresAt: null,
  },
];
